import React from "react";
import { PageHero, Section, Eyebrow, SectionTitle } from "../components/Primitives";
import { MapPin, Clock, Car, Bus, Coffee, Info } from "lucide-react";

const Visit = () => (
  <>
    <PageHero
      eyebrow="Plan a Visit"
      title="Come as you are. Stay as long as you like."
      subtitle="You don’t need to book, dress a certain way, or know anything about Buddhism. If it’s your first time, we’ll show you where the tea is."
    />

    <Section>
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <Eyebrow>Opening times</Eyebrow>
          <SectionTitle>The grounds are open every day.</SectionTitle>
          <div className="mt-8 border border-[#e9dcc0] divide-y divide-[#e9dcc0]">
            {[
              { d: "Monday – Friday", t: "8:00 am – 6:00 pm", n: "Grounds & library open. Office hours 10–4." },
              { d: "Saturday", t: "8:00 am – 8:00 pm", n: "Vietnamese language classes 9–12." },
              { d: "Sunday", t: "7:00 am – 9:00 pm", n: "Dharma talk 10 am · Community lunch 12 pm · Meditation 6:30 pm." },
              { d: "Thursday evening", t: "7:00 – 9:00 pm", n: "Weekly guided meditation in English." },
              { d: "Public holidays", t: "By arrangement", n: "Festival days welcome the whole city. See calendar or call ahead." },
            ].map((row) => (
              <div key={row.d} className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 p-5 bg-[#fdfaf3]">
                <div className="font-serif text-lg text-[#3d2817]">{row.d}</div>
                <div className="text-[#7a2e1f] font-medium">{row.t}</div>
                <div className="text-sm text-[#5a4a3a]">{row.n}</div>
              </div>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="bg-[#f6efe0] border border-[#e9dcc0] p-8">
            <MapPin size={22} className="text-[#7a2e1f]" />
            <h3 className="font-serif text-2xl text-[#3d2817] mt-3">Find us</h3>
            <p className="mt-3 text-[15px] text-[#5a4a3a] leading-relaxed">
              Van Hanh Monastery<br />
              32 Archibald Street<br />
              Lyneham ACT 2602<br />
              Australia
            </p>
            <a
              href="https://www.google.com/maps/search/?api=1&query=32+Archibald+Street+Lyneham+ACT+2602"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline mt-6 text-sm"
            >Open in Maps</a>
          </div>

          <div className="bg-[#fdfaf3] border border-[#e9dcc0] p-8 mt-6">
            <Clock size={22} className="text-[#7a2e1f]" />
            <h3 className="font-serif text-2xl text-[#3d2817] mt-3">Your first visit</h3>
            <ul className="mt-4 space-y-3 text-[15px] text-[#5a4a3a]">
              <li className="flex gap-3"><Coffee size={16} className="mt-1 text-[#c9a15b] flex-shrink-0" />Please remove shoes before entering the meditation hall.</li>
              <li className="flex gap-3"><Info size={16} className="mt-1 text-[#c9a15b] flex-shrink-0" />Modest clothing is appreciated — nothing formal needed.</li>
              <li className="flex gap-3"><Bus size={16} className="mt-1 text-[#c9a15b] flex-shrink-0" />Bus routes 25, 26 stop 300m away on Wattle St.</li>
              <li className="flex gap-3"><Car size={16} className="mt-1 text-[#c9a15b] flex-shrink-0" />Free parking on-site and along Archibald Street.</li>
            </ul>
          </div>
        </aside>
      </div>
    </Section>

    <section className="bg-[#f6efe0] border-y border-[#e9dcc0]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
        <div className="text-center mb-12">
          <Eyebrow>Festival days</Eyebrow>
          <SectionTitle className="mt-6">The whole city is welcome.</SectionTitle>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { t: "Vesak", when: "May full moon", d: "The Buddha’s birth, awakening and passing — a day of chanting, lanterns and shared vegetarian meals." },
            { t: "Tết (Lunar New Year)", when: "Late Jan / Feb", d: "Family blessings, red envelopes for children, and traditional food from dawn until late." },
            { t: "Vu Lan (Parents’ Day)", when: "August", d: "A quiet, moving festival honouring our parents — living and departed. All are invited." },
          ].map((f) => (
            <div key={f.t} className="bg-[#fdfaf3] border border-[#e9dcc0] p-8">
              <div className="text-xs uppercase tracking-[0.25em] text-[#8a6b3f]">{f.when}</div>
              <h3 className="font-serif text-2xl text-[#3d2817] mt-2">{f.t}</h3>
              <p className="mt-3 text-[15px] text-[#5a4a3a] leading-relaxed">{f.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Visit;
